var map = {
	"./pay0.png": "1236",
	"./pay1.png": "ddbd",
	"./pay2.png": "0851",
	"./pay3.png": "9eaf",
	"./pay4.png": "62f9",
	"./pay5.png": "c6ee",
	"./pay6.png": "5b5b",
	"./pay7.png": "9741"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "549b";